export default "__VITE_ASSET__ae87e22c__"